import { render, staticRenderFns } from "./SmartBoxesComponent.vue?vue&type=template&id=e8a23b68&"
import script from "./SmartBoxesComponent.vue?vue&type=script&lang=js&"
export * from "./SmartBoxesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports